module.exports = __webpack_public_path__ + "img/Balance-inspect-portrait.018db070.jpg";